
import routes from './route-constants';
import images from './images';
import appConstants from './app-constants';
import menus from './menus';
import navConstants from './nav-constants';
import faqConstants from './faqs';
import accountConstants from './account-constants';
import reduxActions from './redux-actions';
import apiRoutes from './api-routes';
import { requestStatus, standardHeaders, contentTypes, fetchTypes } from './network-constants';
import { reportResults } from './report-constants';
import { equality } from './search-constants';

var alertMessage = 'Thank you for choosing Oil Services Lab as your trusted oil analysis laboratory. We are currently in the process of updating our systems. As this process completes – you may notice your report history may be incomplete. Please pardon any issues you may experience as we securely provide access to your data via our new system. For all recently submitted samples, you will be receive your email updates as expected. Thank you for your patience.'

export {
    routes,
    images,
    appConstants,
    menus,
    navConstants,
    faqConstants,
    accountConstants,
    reduxActions,
    apiRoutes,
    requestStatus,
    standardHeaders,
    contentTypes,
    fetchTypes,
    reportResults,
    equality,
    alertMessage
}



// WEBPACK FOOTER //
// ./web-app/constants/index.js